import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrandGrid, BrandTile } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { BrandListerGroupedFilterTypes } from '@as-react/common-types';
import { sortAlphabetically } from '@as-react/common-utils';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const BrandLister = ({ items }) => {
    const { t } = useTranslation(I18N_NAMESPACES.brand);
    const aemConfig = useAemConfig();
    const itemKeys = sortAlphabetically(Object.keys(items));
    const getRelativePath = (relativePath) => `${aemConfig.isSingleLanguageSite ? '' : '/' + aemConfig.lang}/${relativePath}.html`;
    const getLogo = (item) => `${aemConfig.brandImageCdnUrl}${item.logo}?timestamp=${item.logoTimestamp}`;
    return (_jsx("div", { "data-testid": "brand-lister", children: itemKeys.map((itemKey) => (_jsxs(Fragment, { children: [_jsx(Box, { paddingBlockStart: "8", paddingBlockEnd: "6", children: _jsx(TextAlpha, { as: "h2", variant: "subheadingS", children: itemKey === BrandListerGroupedFilterTypes.POPULAR
                            ? t('brandlister.overview.popular.brands.title')
                            : itemKey }) }), _jsx(Box, { paddingBlockEnd: { base: '6', md: '8', lg: '10' }, children: _jsx(BrandGrid, { children: items[itemKey].map((item) => (_jsx(BrandTile, { logo: getLogo(item), name: item.description, pagePath: getRelativePath(item.relativePath) }, item.id))) }) })] }, itemKey))) }));
};
